import type { TradeMessage } from "../message/message";

export const DisputeStatus = {
  OPEN: "OPEN",
  UNDER_REVIEW: "UNDER_REVIEW",
  RESOLVED: "RESOLVED",
  REJECTED: "REJECTED",
} as const;

export type DisputeStatus = (typeof DisputeStatus)[keyof typeof DisputeStatus];

export const DisputeOutcome = {
  BUYER_WON: "BUYER_WON",
  SELLER_WON: "SELLER_WON",
} as const;

export type DisputeOutcome =
  (typeof DisputeOutcome)[keyof typeof DisputeOutcome];

export const DisputeWinner = {
  BUYER: "BUYER",
  SELLER: "SELLER",
} as const;

export type DisputeWinner = (typeof DisputeWinner)[keyof typeof DisputeWinner];

export interface DisputeUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface Dispute {
  id: string;
  images: string[];
  reason: string;
  tradeId: string;
  openedById: string;
  openedBy: DisputeUser;
  resolvedBy: DisputeUser;
  trade: {
    seller: DisputeUser;
    buyer: DisputeUser;
    messages: TradeMessage[] | null;
  };
  messages?: TradeMessage[] | null;
  chatMessages?: TradeMessage[] | null;
  outcome: DisputeOutcome;
  status: DisputeStatus;
  resolution?: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  resolvedAt: string;
}

export interface ArrayMeta {
  hasNextPage: boolean;
  hasPrevPage: boolean;
  limit: number;
  page: number;
  total: number;
  totalPages: number;
}

export interface DisputeInterface {
  data: Dispute[];
  meta: ArrayMeta;
}
